import { isDefined } from '@sama/js-core';
import { isUndefined } from 'lodash';
import {
  ObjectState,
  ObjectTransientInfoState,
} from '../../../cross-team-shared/annotation/shared/state/object-state';
import { ShapeState } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { strictValues } from '../../../cross-team-shared/misc-utils/strict-record';
import { ShapeOrGroupOrderItem } from '../../../cross-team-shared/state/shape-group-state';
import { DecimalOverflowError } from '../misc-services/object-sorting.service';

export function getDefaultObjectTransientInfo(): ObjectTransientInfoState {
  return {
    isFilteredOut: true,
    color: '',
    hasMissingRequiredTags: false,
    hasMissingClass: false,
  };
}

export function calculateSafeAverage(a: number, b: number) {
  const result = (a + b) / 2;
  if (result <= Math.min(a, b) || result >= Math.max(a, b)) {
    throw new DecimalOverflowError();
  }
  return result;
}

export function getSortedShapes(
  objects: StrictRecord<number, ObjectState>,
  shapes: StrictRecord<number, ShapeState>,
) {
  const sortedShapes: ShapeOrGroupOrderItem[] = [];
  const sortedObjectIds = strictValues(objects)
    .filter((object) => isUndefined(object.parentId))
    .sort((a, b) => b.sortIndex - a.sortIndex)
    .map((object) => object.index);
  for (const objectId of sortedObjectIds) {
    traverseObjects(+objectId, objects, sortedShapes, shapes);
  }
  return sortedShapes;
}

function traverseObjects(
  objectId: number,
  objectStates: StrictRecord<number, ObjectState>,
  shapeIds: ShapeOrGroupOrderItem[],
  shapes: StrictRecord<number, ShapeState>,
) {
  const object = objectStates[objectId];

  if (!object) {
    return;
  }
  for (const shapeId of object.childShapeIds) {
    if (isDefined(shapes[shapeId])) {
      shapeIds.push({ index: shapeId, type: 'shape' });
    }
  }
  const sortedObjectIds = object.childObjectIds.sort(
    // @ts-ignore -- fix me
    (a, b) => objectStates[b].sortIndex - objectStates[a].sortIndex,
  );
  for (const childObjectId of sortedObjectIds) {
    traverseObjects(+childObjectId, objectStates, shapeIds, shapes);
  }
}
